import { render } from "./BookingsBase.vue?vue&type=template&id=51793f4a&scoped=true"
import script from "./BookingsBase.vue?vue&type=script&lang=js"
export * from "./BookingsBase.vue?vue&type=script&lang=js"

import "./BookingsBase.vue?vue&type=style&index=0&id=51793f4a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51793f4a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSpinner,QBanner,QSelect});
